
    import Vue from 'vue';

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
// 点评类型与分数mapping
export const CommentTypeMapping = {
  positive: { min: 4.5, max: 5 },
  neutral: { min: 3.5, max: 4.5 },
  bad: { min: 0, max: 3.5 },
  custom: { min: undefined, max: undefined },
}

export const LANGUAGES_ENUM = [
  {
    label: $t('77f322'),
    value: 'zh',
  },
  {
    label: $t('79e1aa'),
    value: 'en',
  },
  {
    label: $t('c3a7e6'),
    value: 'jp',
  },
  {
    label: $t('b7810d'),
    value: 'kr',
  },
  {
    label: $t('342e49'),
    value: 'fr',
  },
  {
    label: $t('f65a9c'),
    value: 'de',
  },
  {
    label: $t('04efc3'),
    value: 'ru',
  },
  {
    label: $t('97e49d'),
    value: 'other',
  },
]

export const WARNING_LEVEL_ENUM = [
  {
    label: $t('dc84b0'),
    value: 'S',
    color: '#8F2424',
  },
  {
    label: $t('464888'),
    value: 'A',
    color: '#EE6E6E',
  },
  {
    label: $t('741923'),
    value: 'B',
    color: '#598EE7',
  },
  {
    label: $t('9f06a2'),
    value: 'C',
    color: '#31BFBF',
  },
]

export const HIGH_QUALITY_COMMENT = [
  {
    label: $t('93c157'),
    value: 1,
  },
  {
    label: $t('466236'),
    value: -1,
  },
]

export const REPLY_STATUS_ENUM = {
  replied: 1,
  noReply: 0,
  lateReply: 3,
  noLateReply: 4,
  ReplyChecking: 2,
}
export default {
  CommentTypeMapping,
}
